import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter as Router } from 'react-router'

import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import { BankMatchesToolbar } from '@views/reconciliation/elements/BankMatchesToolbar'
import { BankMatchesToolbarFiltersContextProvider } from '@views/reconciliation/elements/BankMatchesToolbar/context/BankMatchesToolbarFiltersContext'

import { queryClient } from '../../config/queryClient'
import { GlobalFiscalYearContextProvider } from '../../contexts/globalFiscalYearContext'
import { ThemeProvider } from '../../contexts/themeProvider'
import { EmberEventFn } from '../../types/emberEventFn'

class BankMatchesToolbarWebComponent extends DOMModel {
  @byAttrVal organizationId: string
  @registerEvent('updateBankMatchesFilters') updateTransactionType: EmberEventFn
}

type BankMatchesToolbarModuleProps = {
  organizationId: string
  onUpdateBankMatchesFilters: EmberEventFn
}

function BankMatchesToolbarModule({
  organizationId,
  onUpdateBankMatchesFilters,
}: BankMatchesToolbarModuleProps): ReactElement {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <CurrentUserContextProvider>
            <UserOrganizationContextProvider organizationId={organizationId}>
              <GlobalFiscalYearContextProvider organizationId={organizationId}>
                <BankMatchesToolbarFiltersContextProvider onFiltersChange={onUpdateBankMatchesFilters}>
                  <BankMatchesToolbar />
                </BankMatchesToolbarFiltersContextProvider>
              </GlobalFiscalYearContextProvider>
            </UserOrganizationContextProvider>
          </CurrentUserContextProvider>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const BankMatchesToolbarCustomElement = createCustomElement(
  BankMatchesToolbarModule,
  BankMatchesToolbarWebComponent,
  'element',
)

customElements.get('bank-matches-toolbar') ||
  customElements.define('bank-matches-toolbar', BankMatchesToolbarCustomElement)

export default BankMatchesToolbarCustomElement
